import { api } from "@api/api";
import { TiledeskStatus } from "@modules/tiledesk/types";

export interface EnableTiledeskInput {
  agreementId: string;
  agentEmails: string[];
}

export async function enableTiledeskService({
  agreementId,
  agentEmails,
}: EnableTiledeskInput): Promise<TiledeskStatus> {
  const { data } = await api.post<TiledeskStatus>(
    `v1/tiledesk/agreements/${agreementId}/enable/`,
    { agent_emails: agentEmails }
  );
  return data;
}
